import React from 'react'

const Hosting = () => {
    return (
        <div style={{marginLeft: '500px'}}>
            This is hosting page.
        </div>
    )
}

export default Hosting
